module.exports = __webpack_public_path__ + "img/20b347a4-9171-466f-b597-622339f90d72.3cc5a5e1.webp";